import { ReactNode } from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";
import { MockChart } from "./MockChart";

type StatCardProps = {
  title: string;
  value: string | number;
  unit?: string;
  change?: number | null;
  changeLabel?: string;
  trend?: number[];
  trendColor?: string;
  icon?: ReactNode;
  small?: boolean;
};

/**
 * KPI 用の数字カード + ミニチャート
 */
export const StatCard = ({
  title,
  value,
  unit,
  change,
  changeLabel,
  trend,
  trendColor = "#2563eb",
  icon,
  small,
}: StatCardProps) => {
  const hasChange = typeof change === "number";
  const up = (change ?? 0) >= 0;

  return (
    <div className={`stat-card ${small ? "stat-card-sm" : ""}`}>
      <div className="stat-card-head">
        <span className="stat-card-title">{title}</span>
        {icon && <span className="stat-card-icon">{icon}</span>}
      </div>
      <div className="stat-card-value">
        {value}
        {unit && <span className="stat-card-unit">{unit}</span>}
      </div>
      <div className="stat-card-bottom">
        {hasChange ? (
          <span className={`stat-card-change ${up ? "up" : "down"}`}>
            {up ? <ArrowUpRight size={12} /> : <ArrowDownRight size={12} />}
            {up ? "+" : ""}
            {change}%
            {changeLabel && <span className="stat-card-change-label">{changeLabel}</span>}
          </span>
        ) : change === null ? (
          <span className="stat-card-change neutral">
            前期なし
            {changeLabel && <span className="stat-card-change-label">{changeLabel}</span>}
          </span>
        ) : null}
        {trend && (
          <div className="stat-card-mini-chart">
            <MockChart points={trend} color={trendColor} height={36} width={110} fill />
          </div>
        )}
      </div>
    </div>
  );
};
